// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__qHe5d","error":"style_error__3HU7z"};